import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ModuleName } from '../../enums/ModuleName';
import { LandingParamsResponse, SecureLandingService } from '@ex/module/core/services/secure-landing.service';
import { ActivatedRoute, Router } from '@angular/router';
import { products } from '@ex/module/core/data-models/company-permission';
import { LanguageService } from '@ex/module/core/services/language.service';
import { LocalService } from '@ex/module/core/services/local.service';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { ZenSnackbarService, ZenSnackBarTypes } from '../../Theme/services/zen-snackbar.service';
import { child } from 'firebase/database';
import { ChildrenAnimation } from '../../animations/allAnimations';
export interface LandingForm {
  id: string,
  email: string,
  name?: string
}
@Component({
  selector: 'app-shared-landing',
  templateUrl: './shared-landing.component.html',
  styleUrls: ['./shared-landing.component.scss'],
  animations: [ChildrenAnimation],
})
export class SharedLandingComponent {
  ModuleNames = ModuleName
  referenceKey: string;
  logoURL: string;
  secureLanding: boolean;
  paramsResponse: LandingParamsResponse;
  supportedLanguages: any[];
  language: string;
  returnUrl: any;
  valid: boolean = true;
  form: LandingForm = {
    id: '',
    email: '',
    name: ''
  };
  submitted: boolean = false;
  @Input() loader: boolean = false;
  @Input() secureLandingFailed: boolean = false;
  @Input() set landingRequest(params: LandingParamsResponse) {
    if (params?.isWhiteLabel)
      this.logoURL = params.entity.logoURL
    if (!this.logoURL)
      this.logoURL = 'assets/img/svg/logo.svg'; // to be resolved to client's logo
    this.secureLanding = params?.isSecureLanding;
    this.paramsResponse = params;
    this.startLandingFlow(this.referenceKey);
  };
  @Output() submitResult: EventEmitter<{ params: LandingParamsResponse, form: LandingForm, language: string }> = new EventEmitter();

  constructor(private route: ActivatedRoute,
    private languageService: LanguageService,
    private localService: LocalService, private zenSnackBarService: ZenSnackbarService, private translationPipe: TranslatePipe) {

  }

  private startLandingFlow(referenceKey) {
    this.supportedLanguages = this.languageService.getAvailableLanguages();



    let localLanguage = this.localService.getJsonValue('language');
    let sessionLanguage = this.localService.getJsonValue('language');
    if (!localLanguage && !sessionLanguage) {
      this.language = 'EN';
    }
    else if (localLanguage) {
      this.language = localLanguage;
    }
    else if (sessionLanguage) {
      this.language = sessionLanguage;

    }

    this.isArabic();

    this.languageService.language = this.language;
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';

    this.canvasStart();
  }


  onSubmit() {
    this.submitted = true;
    this.form.id = this.form.id.trim();
    this.form.email = this.form.email.trim();
    if (!this.form.id)
      return this.zenSnackBarService.snackBar({ message: this.translationPipe.transform('txtEnterInformation', this.language, ModuleName.Happiness), type: ZenSnackBarTypes.Error });

    if (!this.form.name)
      this.form.name = this.form.id;
    this.submitResult.emit({ params: this.paramsResponse, form: this.form, language: this.language })
  }


  closeDropdown(menu) {
    if (this[menu]) this[menu] = false;
  }
  selectedLanguageChange(event) {
    this.language = event;
    this.localService.setJsonValue('language', this.language);

    this.isArabic()
  }





  canvasStart() {
    var canvas = <HTMLCanvasElement>document.getElementById('c');
    var ctx = canvas.getContext('2d');
    let colors = ['#fbfbfb', '#f7f7f8', '#f4f4f4', '#f0f0f1', '#ededee', '#e9e9ea']
    canvas.height = window.innerHeight;
    canvas.width = window.innerWidth;
    let speed = 1;

    function animate() {
      requestAnimationFrame(animate);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (let color = 0; color < colors.length; color++) {
        ctx.beginPath();
        ctx.moveTo(-200, (canvas.height / 10 + Math.sin(speed * .01) * 200) + color * 100 + color * 100 / 2);
        ctx.bezierCurveTo(
          canvas.width / 2,
          (canvas.height / 4 + Math.cos(speed * .01) * 200) + color * 100 + color * 100 / 2,
          canvas.width / 4,
          (canvas.height / 4 + Math.sin(-speed * .01) * 200) + color * 100 + color * 100 / 2,
          canvas.width + 200,
          (canvas.height / 3 + Math.sin(-speed * .01) * 200) + color * 100 + color * 100 / 2);
        ctx.lineWidth = 130 + color * 100 / 2;
        ctx.strokeStyle = colors[color];
        ctx.stroke();
      }
      speed += .5;
    }

    animate();
  }

  isArabic() {

    if (this.language == 'AR') {
      document.body.classList.remove('ltr');
      document.body.classList.add('rtl');
      document.body.setAttribute("dir", "rtl");
    }
    else {
      document.body.classList.remove('rtl')
      document.body.classList.add('ltr');
      document.body.setAttribute("dir", "ltr");

    }
  }


}
